"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdeaCard = void 0;

var _preact = require("preact");

/**
 * Pure shell component for IdeaCard structure.
 * Accepts title and meta slots for composition.
 *
 * The meta slot should contain multiple elements that will be
 * direct children of .pipeline__idea-meta-info div.
 */
var IdeaCard = function IdeaCard(_ref) {
  var title = _ref.title,
      meta = _ref.meta;
  return (0, _preact.h)("div", {
    className: "pipeline__idea-wrapper"
  }, (0, _preact.h)("span", {
    className: "pipeline__idea-title"
  }, title), (0, _preact.h)("div", {
    className: "pipeline__idea-meta-info"
  }, meta));
};

exports.IdeaCard = IdeaCard;